import { render, staticRenderFns } from "./loginElement.vue?vue&type=template&id=b6d97dbc&scoped=true"
import script from "./loginElement.vue?vue&type=script&lang=js"
export * from "./loginElement.vue?vue&type=script&lang=js"
import style0 from "./loginElement.vue?vue&type=style&index=0&id=b6d97dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d97dbc",
  null
  
)

export default component.exports